import React, {useState} from 'react';
import {RxUpdate} from 'react-icons/rx';

import {isMasterFirebaseUser} from '../library/GeneralUse';
import {hoursSinceLastUsernameUpdate} from '../library/FirestoreUser';

import {useFirebaseAuthUserStore} from '../stores/FirebaseAuthUserStore';
import {useFirestoreUserStore} from '../stores/FirestoreUserStore';

import {ASCIIArt} from '../components/ASCIIArt';

import {AccountInfo} from '../components/Account/AccountInfo';
import {SignoutButton} from '../components/Account/SignoutButton';
import {UsernameForm} from '../components/Account/UsernameForm';

import {Content} from '../components/PrimaryContent/Box/Content';
import {Header} from '../components/PrimaryContent/Box/Header';
import {PrimaryContentBox} from '../components/PrimaryContent/Box/PrimaryContentBox';
import {PrimaryContentRow} from '../components/PrimaryContent/PrimaryContentRow';

// https://tailwindflex.com/@alok/feature-showcase
const style = {
	ASCIIContainer: `flex flex-col gap-y-8`,
	levelDisplay: `text-center`,
	row: `flex flex-row   w-full`,
	disabledUsernameForm: `flex flex-row justify-between gap-x-4   p-4`,
	disabledUsernameFormSubmitButton: `flex basis-1/6 justify-center items-center   p-2   text-whirlwindLight   bg-whirlwindDisabled   rounded   opacity-65`,
	disabledUsernameFormTextInput: `flex basis-5/6   p-4   text-xl text-whirlwindDisabled   bg-whirlwindDarkest   rounded-md   opacity-90`,
	usernameFormOuterContainer: `flex justify-center   w-full`,
	usernameFormInnerContainer: `flex flex-col   max-w-96`,
};

export const Account = () => {
	// Zustand
	const firebaseAuthUser = useFirebaseAuthUserStore(
		(state) => state.firebaseAuthUser,
	);
	const firestoreUser = useFirestoreUserStore((state) => state.firestoreUser);

	// Component state
	const [currentUsername, setCurrentUsername] = useState(
		firestoreUser?.username,
	);
	const [isValidUsername, setValidUsername] = useState(true);

	return (
		<>
			<PrimaryContentRow>
				<PrimaryContentBox tailwindcss={'basis-full max-w-full'}>
					<Header>Welcome,</Header>
					<Content>
						<div className={style.ASCIIContainer}>
							<ASCIIArt
								dataTestId={`accountBanner`}
								tailwindcss
								text={currentUsername ? currentUsername : '...'}
							/>
							<span className={style.levelDisplay}>
								Currently Level 1 (Novice)
							</span>
						</div>
						<div className={style.usernameFormOuterContainer}>
							<div className={style.usernameFormInnerContainer}>
								{isMasterFirebaseUser(firebaseAuthUser?.uid) ||
								hoursSinceLastUsernameUpdate() > 24 ||
								isNaN(hoursSinceLastUsernameUpdate()) ? (
									<UsernameForm
										setCurrentUsername={setCurrentUsername}
										setValidUsername={setValidUsername}
									/>
								) : (
									<>
										<div
											className={style.disabledUsernameForm}
											data-test-id="usernameForm_TEST">
											<input
												className={
													style.disabledUsernameFormTextInput
												}
												data-test-id="usernameFormText_TEST"
												type="text"
												defaultValue={firestoreUser?.username}
												disabled
												placeholder="username"
											/>
											<button
												className={
													style.disabledUsernameFormSubmitButton
												}
												data-test-id="usernameFormButton_TEST"
												disabled>
												<RxUpdate size={40} />
											</button>
										</div>
										<div
											className={`text-center`}
											data-test-id={`usernameFormMessage_TEST`}>
											You can change username in{' '}
											{24 - hoursSinceLastUsernameUpdate()} hours
										</div>
									</>
								)}
								<div
									className={`text-center text-whirlwindRed`}
									data-test-id={`usernameFormMessage_TEST`}>
									{isValidUsername ? `` : `Pick a different username`}
								</div>
							</div>
						</div>
					</Content>
				</PrimaryContentBox>
			</PrimaryContentRow>
			<PrimaryContentRow>
				<PrimaryContentBox tailwindcss={'basis-3/4 max-w-[75%]'}>
					<Header>Account Info</Header>
					<Content>
						<AccountInfo />
					</Content>
				</PrimaryContentBox>
				<PrimaryContentBox tailwindcss={'basis-1/4 max-w-[25%]'}>
					<Header>Exit</Header>
					<Content>
						<SignoutButton />
					</Content>
				</PrimaryContentBox>
			</PrimaryContentRow>
		</>
	);
};
